import React, { Component } from "react"
import AnimatedCheckmarkButton from "../common/animatedCheckmarkButton"
import config from "react-global-configuration"
import * as tracking from "../../helpers/tracking"
import { trackTravelPlannerParkingSearch } from "../../../../src/helpers/tracking"
import priceFormatter from "../../helpers/priceFormatter"

class ParkingProductHighlightElement extends Component {
  static defaultProps = {
    image: "/static/airline-sales-hero.png",
    name: "Economy",
    description: "Få en let udvendig rengøring af din bil. Bilen bliver vasket og aftørret i hånden.",
    price: "245 DKK",
    grid_classes: "grid-item col--12 col-xs--4",
    buttonText: "Tilføj",
    buttonOnClick: undefined,
    buttonClass: "",
    modalTemplate: "carServiceModal",
    noOriginalPrice: true,
    modifier_class: "parking-product-highlight--stagger",
    type: "",
    typeText: "",
    modalButtonText: "",
    modalButtonOnClick: undefined,
    labelPrice: "",
  }

  state = {}

  handleTrackingClick = (callback, eventAction, eventLabel) => {
    tracking.trackParkingFlowClick(eventAction, eventLabel)
    callback()
  }

  readMoreTrackingHandler = (isExtraService) => {
    if (isExtraService) {
      this.handleTrackingClick(this.props.modalButtonOnClick, "extra services", `read more - ${this.props.product.name}`)
    } else if (this.props.flightId) {
      trackTravelPlannerParkingSearch(
        "track-event",
        "product stagger",
        "read more",
        this.props.flightId,
        this.props.arrivalDate,
        this.props.departureDate,
      )
      this.props.modalButtonOnClick()
    } else {
      this.handleTrackingClick(this.props.modalButtonOnClick, "product stagger", "read more")
    }
  }

  reserveTrackingHandler = (isExtraService) => {
    if (isExtraService) {
      this.handleTrackingClick(this.props.buttonOnClick, "extra services", `add - ${this.props.product.name}`)
    } else if (this.props.flightId) {
      trackTravelPlannerParkingSearch(
        "track-event",
        "product stagger",
        "reserve",
        this.props.flightId,
        this.props.arrivalDate,
        this.props.departureDate,
      )
      this.props.buttonOnClick()
    } else {
      this.handleTrackingClick(this.props.buttonOnClick, "product stagger", "reserve")
    }
  }

  render() {
    const {
      type,
      typeText,
      icon,
      image,
      name,
      location,
      ribbonText,
      description,
      usp,
      modalTemplate,
      labelPrice,
      price,
      urgency,
      priceSub,
      noOriginalPrice,
      originalPrice,
      buttonText,
      modalButtonText,
      modifier_class,
      grid_classes,
      result,
      isExtraService,
      isLoggedIn,
      product,
      globals,
    } = this.props

    const highlightModalButtonText = config.get("textKeys.parkingList.listElement.readMore") || "Læs Mere"

    const textKeys = config.get("textKeys.parkingList.listElement") || {}
    const extraServicesElementTextKeys = config.get("textKeys.extraServices.element") || {}
    const affiliateCheck = this.props.affiliateCode && result.affiliateResult && product.dynamicFields.affiliateBanner

    let colorStyle = {}
    let ribbonSpacing = {}
    if (result?.thirdPartyPromoLabelColorCode && !affiliateCheck && !(result.originalPrice > result.totalPrice && globals.promotionName)) {
      colorStyle = { backgroundColor: result.thirdPartyPromoLabelColorCode }
    }
    if (isExtraService) {
      ribbonSpacing = { display: "block", marginBottom: "2px" }
    }

    return (
      <div className={`parking-product-highlight ${modifier_class} ${grid_classes}`}>
        {type ? (
          <div className={`parking-product-highlight__type parking-product-highlight__type--${type}`}>
            <span>{typeText}</span>
          </div>
        ) : (
          ""
        )}

        <div className="parking-product-highlight__inner">
          {icon ? (
            <div className="parking-product-highlight__icon">
              <img src={icon} />
            </div>
          ) : (
            ""
          )}

          {image ? (
            <div className="parking-product-highlight__image">
              <img src={image} />
            </div>
          ) : (
            ""
          )}

          <div className="parking-product-highlight__name">
            <h4>
              {name}

              {location ? <span>{location}</span> : ""}
            </h4>
            {ribbonText && ribbonText !== "" ? (
              <span className="angled-ribbon angled-ribbon--dynamic" style={ribbonSpacing}>
                <span className="angled-ribbon__inner" style={colorStyle}>
                  <span className="text">{ribbonText}</span>
                </span>
              </span>
            ) : (
              ""
            )}

            {isExtraService ? <span dangerouslySetInnerHTML={{ __html: description }}></span> : ""}
          </div>

          {!isExtraService && usp && usp.bullets ? (
            <div className="parking-product-highlight__usp">
              <ul>
                {usp.bullets.map((u, index) => (
                  <li key={index}>
                    <svg className="svg-icon svg-icon--checkmark">
                      <use xlinkHref="/dist/svg/symbols.svg#svg-checkmark"></use>
                    </svg>
                    {u}
                  </li>
                ))}
              </ul>
            </div>
          ) : (
            ""
          )}

          {highlightModalButtonText ? (
            <div className="parking-product-highlight__readmore">
              <button className="link js--open-modal" onClick={() => this.readMoreTrackingHandler(isExtraService)}>
                {highlightModalButtonText}
              </button>
            </div>
          ) : (
            ""
          )}
        </div>

        <div className="parking-product-highlight__footer">
          <div className="parking-product-highlight__price">
            <span className="parking-product-highlight__label-price">{labelPrice}</span>
            {result?.showMemberPrice ? <span className="parking-product-highlight__label-price">{textKeys.memberPrice || "Medlemspris"}</span> : ""}

            <h3>
              {priceFormatter(result?.showMemberPrice ? result.memberPrice : price)}
              {urgency ? <span>{textKeys.fewSpots || "Få pladser online"}</span> : ""}
              {priceSub ? <small>{priceSub}</small> : ""}
            </h3>

            {result?.showMemberPrice ? (
              <p>
                {textKeys.nonMemberPrice || "Ikke medlem"} <em className={isLoggedIn ? "line-through" : ""}> {priceFormatter(result.totalPrice)}</em>
              </p>
            ) : (
              ""
            )}
            {result?.showPayOnFootPrice ? (
              <p>
                {textKeys.normalOnlinePrice || "Normal onlinepris: "}
                <em className={"line-through"}>{priceFormatter(result.payOnFootPrice)}</em>
              </p>
            ) : (
              ""
            )}
            {result?.showOriginalPrice ? (
              <p>
                {textKeys.previousPrice || "Førpris: "}
                <em className={"line-through"}>{priceFormatter(result.originalPrice)}</em>
              </p>
            ) : (
              ""
            )}
            {result?.showDriveInPrice ? (
              <p>
                {textKeys.drivePrice || "Drive in-pris: "}
                <em className={""}>{priceFormatter(result.barrierTariff)}</em>
              </p>
            ) : (
              ""
            )}
          </div>

          <div className="parking-product-highlight__button">
            {this.props.animateButton ? (
              <AnimatedCheckmarkButton
                buttonText={buttonText}
                onClickHandler={() => this.reserveTrackingHandler(isExtraService)}
                isSelected={this.props.isSelectedProduct}
              />
            ) : (
              <button
                className={`button button--small button--general ${this.props.buttonClass}`}
                onClick={() => this.reserveTrackingHandler(isExtraService)}
              >
                <span className="text">{buttonText}</span>
              </button>
            )}
          </div>
        </div>
      </div>
    )
  }
}
export default ParkingProductHighlightElement
